import Immutable from 'immutable';

import { get, omit } from 'lodash-es';

import { getAuthorizationFromParams, getThemeFromParams } from '../../Utils/Utils';
import { contracts } from './contracts';
// Customer
import { dynamicState } from '../customer/initialState-wrapper';
import { dashboard } from './dashboard';
import { parties } from './parties';
import { plugins } from './plugins';
import { products } from './products';
import { quotations } from './quotations';
import { salesroutes } from './salesroutes';
import { surveys } from './surveys';
import { system } from './system';
import { theme } from './theme';

const defaultAuth = {
  loading: false,
  isAuthenticated: false,
  isFetching: false,
};

const localAuth = JSON.parse(localStorage.getItem('auth'));
const auth = history => {
  const { location } = history;
  // get authorization from parameters
  const paramAuth = { ...localAuth, ...getAuthorizationFromParams(location) };

  localStorage.setItem('auth', JSON.stringify(paramAuth));

  return { ...defaultAuth, ...paramAuth, ready: false };
};

const consolidateTheme = history => {
  const { location } = history;
  const selectedTheme = getThemeFromParams(location);
  const dynamicTheme = get(dynamicState, 'theme', theme);
  const localTheme = localStorage.getItem('theme');
  let consolidatedTheme = { ...theme, ...dynamicTheme };
  if (localTheme) {
    try {
      const logo = { ...get(consolidatedTheme, 'logo'), current: get(JSON.parse(localTheme), 'logo.current') };
      consolidatedTheme = { ...consolidatedTheme, current: get(JSON.parse(localTheme), 'current'), logo };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('no theme found in local storage', error);
    }
  }
  if (selectedTheme) {
    const logo = { ...get(consolidatedTheme, 'logo'), current: selectedTheme };
    consolidatedTheme = { ...consolidatedTheme, current: selectedTheme, logo };
  }
  localStorage.setItem('theme', JSON.stringify(consolidatedTheme));

  return consolidatedTheme;
};

const defaultState = history => ({
  auth: auth(history),
  contracts,
  dashboard,
  products,
  surveys,
  quotations,
  settings: {},
  stats: {},
  system,
  parties,
  plugins,
  salesroutes,
  theme: consolidateTheme(history),
});

const initialState = history => Immutable.fromJS({ ...defaultState(history), ...omit(dynamicState, ['theme']) });

export default initialState;
